<template>
    <div style="margin-left: 75px">
        <!-- site dialog -->
        <d-site
            v-if     = "items"
            v-model  = "showSite"
            :site-id = "siteId"
        />
        <!-- site dialog -->

        <d-service-partner
            v-model = "editPartner"
            @stored = "onStored"
        />

        <company-app-bar
            title         = "SERVICE"
            :categories   = "['mnu']"
            @search       = "onSearch"
            @clear-filter = "onClearFilter"
        >
            <template v-slot:toolbar>
                <c-toolbar-button
                    icon     = "mdi-plus"
                    color    = "primary"
                    :size    = "22"
                    :tooltip = "$t('msd.service.menu.create.tooltip')"
                    class    = "ml-2"
                    @click   = "onCreate"
                />
            </template>
        </company-app-bar>

        <div class="v-flex" >
            <c-index
                v-if           = "items"
                :items         = "items"
                :enable-search = "false"
                :criterion     = "criteria"
                :filter-height = "345"
                :filter-on     = "filterOn"
                :filter        = "indexFilter"
                :miminize      = "false"
                children       = "branches"
                @selected      = "onCompany"
                @clear-filter  = "onClearFilter"
                @side          = "onSide"
                ref            = "index"
                style          = "position: relative; margin-right: 75px;"
            >
                <template v-slot:filter>
                    <c-service-filter
                        @changed  = "onFilter"
                        @customer = "onCustomer"
                        ref       = "filter"
                    />
                </template>

                <template v-slot:item="{ item }">
                    <div class="entry">
                        {{ item.name }}
                    </div>
                    <v-spacer />
                    <company-roles
                        :item     = "item"
                        :selected = "selected && selected.id === item.id"
                    />
                </template>

                <template v-slot:detail="{ item }">
                    <div v-if="item" class="mt-1 h-100" style="width: calc(100% + 12px);">
                        <v-row class="no-frame h-100">
                            <!-- edit company -->
                            <v-col class="no-frame pr-0 h-100" style="width: 33.33%" :class="!item.show ? 'pl-4 pr-2' : 'pl-4 pl-0'">
                                <c-servicepartner-edit
                                    v-if     = "selected && selected.id !== unknownCompany.id"
                                    :company = "selected"
                                    style    = "margin-top: 9px; height: 480px"
                                />

                                <service-customer-list
                                    style    = "margin-top: 14px; height: calc(100% - 580px)"
                                    v-if     = "selected && !selected.parent"
                                    @customer="onCompanyCustomer"
                                    ref      = "customerList"
                                />
                            </v-col>

                            <!-- contracts -->
                            <v-col
                                class  = "no-frame pl-2 pr-0"
                                :class = "item.show ? 'pl-4' : 'pl-0'"
                            >
                                <c-contact-card-iterator
                                    v-if         = "!contractsVisible"
                                    :items       = "contacts.items"
                                    :company-id  = "selected ? selected.id : null"
                                    :contract-id = "contracts.selected ? contracts.selected.id : null"
                                    :customer    = "customer.detail ? customer.detail.id : null"
                                    @selected    = "onContactSelected"
                                    class        = "w-100"
                                />
                                <c-flip-card
                                    v-if   = "contractsVisible"
                                    v-model="flip"
                                    color="white--text" :top="17" :right="90"
                                >
                                    <template v-slot:front>
                                        <c-contract-service-card-iterator
                                            :items       = "contracts.items"
                                            :customer-id = "customer.detail ? customer.detail.id : null"
                                            :contact-id  = "contacts.selected ? contacts.selected.id : null"
                                            :company-id  = "selected ? selected.id : null"
                                            @selected    = "onContractSelected"
                                            @contracts-changed = "onContractsChanged"
                                            @update:items = "contracts.items = $event"
                                            class        = "w-100"
                                            ref          = "contracts"
                                        />
                                    </template>
                                    <template v-slot:back>
                                        <c-contact-card-iterator
                                            :items       = "contacts.items"
                                            :company-id  = "selected ? selected.id : null"
                                            :contract-id = "contracts.selected ? contracts.selected.id : null"
                                            :customer-id = "customer.detail ? customer.detail.id : null"
                                            :combine-allowed = "true"
                                            @selected    = "onContactSelected"
                                            class        = "w-100"
                                        />
                                    </template>
                                </c-flip-card>
                            </v-col>
                            <!-- contracts -->

                            <v-col class="no-frame pl-1">
                                <c-site-card-iterator
                                    v-if      = "selected"
                                    role      = "MNT"
                                    :customer = "customer.detail"
                                    :contract = "contracts.selected"
                                    :contact  = "contacts.selected"
                                    :visible-contracts = "contracts.visible"
                                    :contract-height = "contractHeight"
                                    class     = "w-100"
                                    @site     = "onSite"
                                    @click    = "onclick"
                                    ref       = "siteIterator"
                                >
                                    <template v-slot:editor="{ site }">
                                        <c-contract-mnt-editor
                                            v-if  = "isMaintenance"
                                            :unit = "site"
                                        />
                                        <c-contract-esc-editor
                                            v-if  = "!isMaintenance"
                                            :unit = "site"
                                        />
                                    </template>
                                </c-site-card-iterator>
                            </v-col>
                        </v-row>
                    </div>
                </template>
            </c-index>
        </div>
    </div>
</template>

<script>

import Core                         from "@/modules/core/service/Core";
import CIndex                       from "@/modules/core/components/utils/CIndex";
import CompanyRoles                 from "@/modules/msd/company/common/components/controlls/CompanyRoles";
import CSiteCardIterator            from "@/modules/msd/unit/components/controlls/CSiteCardIterator";
import CServicepartnerEdit          from "@/modules/msd/company/servicepartner/components/controlls/CServicepartnerEdit";
import CServiceFilter               from "@/modules/msd/company/servicepartner/components/main/CServiceFilter";
import Company                      from "@/modules/msd/company/common/service/Company";
import Contract                     from "@/modules/msd/company/contract/service/Contract";
import ServiceCustomerList          from "@/modules/msd/company/servicepartner/components/controlls/ServiceCustomerList";
import CFlipCard                    from "@/modules/core/components/utils/CFlipCard";
import DSite                        from "@/modules/msd/unit/components/dialog/DSite";
import CContactCardIterator         from "@/modules/msd/company/contact/components/controlls/CContactCardIterator";
import CContractServiceCardIterator from "@/modules/msd/company/contract/components/controls/CContractServiceCardIterator";
import CompanyAppBar                from "@/modules/msd/company/common/components/nav/CompanyAppBar";
import CToolbarButton               from "@/modules/core/components/utils/CToolbarButton";
import DServicePartner              from "@/modules/msd/company/servicepartner/components/controlls/DServicePartner";
import CContractMntEditor           from "@/modules/msd/company/contract/components/controls/mnt/CContractMntEditor.vue";
import CContractEscEditor           from "@/modules/msd/company/contract/components/controls/esc/CContractEscEditor.vue";

const config = {
    roles: [
        "MNU",
        "FCM",
        "MNT",
        "EMC",
        "PM",
        "AU",
        "NC",
        "MF"
    ],
}

export default {
    name: "MService",

    components: {
        CContractEscEditor,
        CContractMntEditor,
        DServicePartner,
        CToolbarButton,
        CompanyAppBar,
        CContractServiceCardIterator,
        CContactCardIterator,
        DSite,
        CFlipCard,
        ServiceCustomerList,
        CServiceFilter,
        CServicepartnerEdit,
        CSiteCardIterator,
        CompanyRoles,
        CIndex,
    },

    data: () => ({
        dragtype  : null,
        showSite  : false,
        siteId    : null,
        flip: false,
        items: null,
        selected: null,
        criteria: null,
        customers: [],
        filterOn : false,
        editPartner: false,
        contractHeight: 0,

        customer: {
            index: null,
            detail: null
        },

        contracts: {
            items   : null,
            selected: null,
            visible : null,
            edit    : false,
            filter  : {
                types   : ["MNT", "ESC"],
                active  : true,
                inactive: false,
                customer: null,
                role    : 1
            }
        },
        contacts: {
            items   : null,
            selected: null,
            editselected: null,
            edit    : false,
            members : false,
            combine : false,
            refresh : 0,
            filter  : {
                customer: null,
            },
        },

        unknownCompany: null,
    }),

    computed: {
        isValidRole () {
            if (!this.selected || !this.selected.roles) {
                return false;
            }

            return this.selected.roles.filter (role => role.id === Company.roles.maintenance || role.id === Company.roles.escalation).length > 0;
        },

        contractsVisible () {
            return this.isValidRole;
        },

        isMaintenance () {
            console.log("selected", this.contracts.selected,  this.contracts.selected && this.contracts.selected.type.id === Contract.enums.types.mnt)
            return this.contracts.selected && this.contracts.selected.type.id === Contract.enums.types.mnt;
        }
    },

    mounted() {
        Core.init.load(this.$store, false).then(() => {
            this.load();
        })
    },

    methods: {
        load() {
            Company.index(this.customer.index ? this.customer.index.id : null, config.roles, true, (data) => {
                const index = data.findIndex(c => c.id === Company.unknown)
                if (index >= 0) {
                    this.unknownCompany = data[index];
                    this.unknownCompany.name = "Kontakte ohne Unternehmen";
                    data.splice(index, 1);
                }

                this.items = data;
                this.$nextTick(() => {
                    this.$refs.index.refresh();
                })
            })
        },

        loadCompany() {
            Company.get(this.selected.id).then ((data) => {
                this.selected = data;
            });

            Company.contacts(this.selected.id, this.contacts.filter, (data) => {
                this.contacts.items = data;
            });

            Contract.list(this.selected.id, this.createContractFilter(), (data) => {
                this.contracts.items = data;
            });
        },

        onSide(value) {
            console.log(value)
        },

        onSearch(criteria) {
            this.criteria = criteria;
        },

        onCreate () {
            this.editPartner = true;
        },

        onCompany(item) {
            if (this.$refs.customerList) {
                this.$refs.customerList.reset();
            }

            if (!item) {
                this.selected = null;
                this.$store.dispatch("setTitle", null);
                this.contracts.items = null;
                this.contracts.selected = null;
                this.contacts.items = null;
                this.contacts.selected = null;
                this.customer.detail = null;
                return;
            }

            this.$refs.index.setSelected(item);
            this.$store.dispatch("setTitle", item.name);
            this.selected = item;
            this.contracts.selected = null;
            this.contacts.selected = null;
            this.customer.detail = null;

            this.loadCompany();
        },

        onCustomer(customer) {
            if (customer) {
                if (!this.customer.index || this.customer.index.id !== customer.id) {
                    this.customer.index = customer;
                    this.load();
                } else if (this.customer.index) {
                    this.customer.index = null;
                    this.load();
                }
            } else {
                this.customer.index = null;
                this.contacts.selected = null;
                this.load();
            }
        },

        onCompanyCustomer(customer) {
            this.customer.detail = customer;
            this.contacts.filter.customer = null; //this.customer.detail;
            this.contracts.selected = null;
            this.contacts.selected = null;

            if (!customer) {
                this.contracts.items = null;
                this.contacts.items = null;
            }

            this.loadCompany();
        },

        onFilter() {
            this.filterOn = this.$refs.filter.filterOn();
            this.$refs.index.refresh();
        },

        onClearFilter() {
            this.criteria = null;
            this.$refs.filter.clearFilter();
            this.filterOn = this.$refs.filter.filterOn();
        },

        onFilterChanged() {
            Contract.list(this.selected.id, this.createContractFilter(), (data) => {
                this.contracts.items = data;
            });
        },

        createContractFilter() {
            this.contracts.filter.customer = this.customer.detail ? this.customer.detail.id : null;
            return this.contracts.filter;
        },

        onContractSelected(contract) {
            this.$refs.siteIterator.onEndAssingMode();
            this.contacts.selected = null;
            this.contracts.selected = contract;
            if (this.isMaintenance) {
                this.contractHeight = 102;
            } else {
                this.contractHeight = 150;
            }
        },

        onContractsChanged(visibleContracts) {
            this.contracts.visible = visibleContracts;
        },

        onContactSelected(contact) {
            this.$refs.siteIterator.onEndAssingMode();
            this.contracts.selected = null;
            this.contacts.selected = contact;
        },

        onContactSaved(contact) {
            this.contacts.editselected = null;
            const index = this.contacts.items.findIndex(c => c.id === contact.id);
            if (index >= 0) {
                this.contacts.items[index] = contact;
            } else {
                this.contacts.items.push(contact);
            }

            this.contacts.refresh++;
        },

        onSite(site) {
            this.showSite = true;
            this.siteId = site.id;
        },

        onclick (site) {
            if (!site || !site.contractMntId || this.flip || !this.contracts) {
                return;
            }

            const contract = this.contracts.items.find (contract => contract.id === site.contractMntId);
            if (!contract) {
                return;
            }

            this.$refs.contracts.select(contract);
        },

        onStored () {
            this.load();
        },

        isSelected(company, item) {
            return company && company.selected && company.id === item.id;
        },

        indexFilter(item, search) {
            if (search && !Core.filter.includes(item.name.toUpperCase(), search.toUpperCase())) {
                return false;
            }

            if (!this.$refs.filter) {
                return true;
            }

            return this.$refs.filter.match(item);
        },
    }
}
</script>

<style scoped>

.entry {
    max-width: calc(100% - 120px);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

::v-deep .contact-selected {
    background-color: aliceblue;
}

</style>